import { render, staticRenderFns } from "./WebPagesBuilder.vue?vue&type=template&id=60532f59&"
import script from "./WebPagesBuilder.vue?vue&type=script&lang=js&"
export * from "./WebPagesBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports